import { render, staticRenderFns } from "./NewNewsApp.vue?vue&type=template&id=2fdcf35c&"
import script from "./NewNewsApp.vue?vue&type=script&lang=js&"
export * from "./NewNewsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports